$(document).ready(function () {
  // Minimalize menu
  $('.navbar-minimalize').on('click', function (event) {
    event.preventDefault();
    $("body").toggleClass("sidebar-collapsed");
  });

  $('#advanced_search').on('click', function (event) {
    event.preventDefault();
    if($('#advanced_search')[0].outerText == 'ADVANCED SEARCH') {
      $('.advanced_search_row').removeClass('hidden');
      $('.simple_search_row').addClass('hidden');

      $('#advanced_search').text('Simple Search');
    } else {
      $('.simple_search_row').removeClass('hidden');
      $('.advanced_search_row').addClass('hidden');

      $('#advanced_search').text('Advanced Search');
    }
  })

  $('#advanced_search').click(); //advanced search is default

  $('#request_strains').on('click', function (event) {
    event.preventDefault();

    $('#cart_button_row').addClass('hidden');
    // $('#cart_button_row').css('height', '0px');

    $('#cart_request_form').removeClass('hidden');
    // $('#cart_request_form').css('height', '530px');
  })
});
